import React from 'react'
import {MenuItem} from './MenuItem'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../../app/modules/auth'

export function MenuInner() {
  const intl = useIntl()
  const {currentUser} = useAuth()
  return (
    <>
      <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/dashboard' />
      {currentUser?.wallet ? (
        <MenuItem title={`${currentUser.wallet} تومان`} to='/payment/charge' />
      ) : 
        <MenuItem title={`کیف پول خالی است`} to='/payment/charge' />
      }
    </>
  )
}
